import React from 'react'
import { Row, H1, MarginBox } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function EditorHandbookHeader(): JSX.Element {
  const [t] = useTranslation()

  return (
    <MarginBox marginX="nano" marginY="nano">
      <Row wrap alignItemsY="middle">
        <H1 size="H3" growX>
          {t('editor-handbook.editor-handbook-header.header', 'Editor Handbook')}
        </H1>
      </Row>
    </MarginBox>
  )
}
